export enum ACCOUNT_TYPE {
    EMPLOYEE = 'employee',
    AFFILIATE = 'affiliate',
    SYSTEM = 'system',
    ADVERTISER =  'advertiser',
}
